import { Button, Checkbox, Form, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { EmployeeAddressInformationUpdate, loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { getAllMaster, getCitiesByStateId } from "../../../redux/rtk/features/masters/masterSlice";
import BtnEditSvg from "../Button/btnEditSvg";

const { Option } = Select;

const filterSelectOption = (input, option) =>
  String(option?.children ?? "")
    .toLowerCase()
    .includes(String(input).toLowerCase());

const AddressEditPopup = ({ userId, user }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [isSameAsCurrent, setIsSameAsCurrent] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams();
  const masterData = useSelector((state) => state?.masters?.masters)||[];
  const cities = useSelector((state) => state.masters.cities);
  const [permanentCities, setPermanentCities] = useState([]);


  // Fetch master data on component mount
  useEffect(() => {
    dispatch(getAllMaster());
  }, [dispatch]);

  // Prefill form with existing user address data when modal opens
  useEffect(() => {
    if (isModalOpen && user) {
      const isSame = user.IsPermanentAddressSame === 1;
      setIsSameAsCurrent(isSame);
      form.setFieldsValue({
        EmployeeId: id,
        DataStatus: 1,
        IsSameAsCurrent: isSame,
        CStreetAddress: user.CurrentStreetAddress || "",
        CCityId: user.CurrentCityId ? Number(user.CurrentCityId) : undefined,
        CStateId: user.CurrentStateId ? Number(user.CurrentStateId) : undefined,
        CCountryId: user.CurrentCountryId ? Number(user.CurrentCountryId) : undefined,
        CZipCode: user.CurrentZipCode || "",
        PStreetAddress: user.PermanentStreetAddress || "",
        PCityId: user.PermanentCityId ? Number(user.PermanentCityId) : undefined,
        PStateId: user.PermanentStateId ? Number(user.PermanentStateId) : undefined,
        PCountryId: user.PermanentCountryId ? Number(user.PermanentCountryId) : undefined,
        PZipCode: user.PermanentZipCode || "",
      });

      // Fetch cities for prefilled states
      if (user.CurrentStateId) {
        dispatch(getCitiesByStateId(Number(user.CurrentStateId)));
      }
      // if (user.PermanentStateId && !isSame) {
      //   dispatch(getCitiesByStateId(Number(user.PermanentStateId)));
      // }
      if (user.PermanentStateId && !isSame) {
        dispatch(getCitiesByStateId(Number(user.PermanentStateId))).then((res) =>
          setPermanentCities(res.payload)
        );
      }

    }
  }, [isModalOpen, user, form, id, dispatch]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setIsSameAsCurrent(false);
  };

  const handleSameAsCurrentChange = (e) => {
    const checked = e.target.checked;
    setIsSameAsCurrent(checked);
    if (checked) {
      const currentAddress = form.getFieldsValue([
        "CStreetAddress",
        "CCityId",
        "CStateId",
        "CCountryId",
        "CZipCode",
      ]);
      form.setFieldsValue({
        PStreetAddress: currentAddress.CStreetAddress,
        PCityId: currentAddress.CCityId,
        PStateId: currentAddress.CStateId,
        PCountryId: currentAddress.CCountryId,
        PZipCode: currentAddress.CZipCode,
      });
    }
  };

  // const handleStateChange = (stateId, type) => {
  //   // console.log("handleStateChange-stateId, type", stateId, type);

  //   if (stateId) {
  //     dispatch(getCitiesByStateId(stateId));
  //     form.setFieldsValue({ [`${type}CityId`]: undefined });
  //     if (type === "C" && isSameAsCurrent) {
  //       form.setFieldsValue({ PCityId: undefined, PStateId: stateId });
  //     }
  //     if (type === "P" && !isSameAsCurrent) {
  //       form.setFieldsValue({ PCityId: undefined });
  //     }
  //   }
  // };

  const handleStateChange = async (stateId, type) => {
    if (stateId) {
      const resultAction = await dispatch(getCitiesByStateId(stateId));
      const fetchedCities = resultAction.payload;

      if (type === "C") {
        form.setFieldsValue({ CCityId: undefined });
        if (isSameAsCurrent) {
          form.setFieldsValue({ PStateId: stateId, PCityId: undefined });
        }
      } else if (type === "P" && !isSameAsCurrent) {
        form.setFieldsValue({ PCityId: undefined });
        setPermanentCities(fetchedCities);
      }
    }
  };


  const handleCountryChange = (countryId, type) => {
    // console.log("handleCountryChange-countryId,type", countryId, type);

    form.setFieldsValue({ [`${type}StateId`]: undefined, [`${type}CityId`]: undefined });
    if (isSameAsCurrent && type === "C") {
      form.setFieldsValue({ PCountryId: countryId, PStateId: undefined, PCityId: undefined });
    }
  };

  const handleCityChange = (cityId, type) => {
    if (isSameAsCurrent && type === "C") {
      form.setFieldsValue({ PCityId: cityId });
    }
  };

  const handleStreetChange = (e, type) => {
    if (isSameAsCurrent && type === "C") {
      form.setFieldsValue({ PStreetAddress: e.target.value });
    }
  };

  const handleZipChange = (e, type) => {
    if (isSameAsCurrent && type === "C") {
      form.setFieldsValue({ PZipCode: e.target.value });
    }
  };

  const onFinish = async (values) => {
    try {
      const response = await dispatch(EmployeeAddressInformationUpdate({
        ...values,
        IsSameAsCurrent: isSameAsCurrent,
      }));
      if (response.payload.message === "success") {
         dispatch(loadSingleStaff(id));
        setIsModalOpen(false);
        form.resetFields();
        setIsSameAsCurrent(false);
      }
    } catch (error) {
      // console.error("Error updating address details:", error);
    }
  };

  return (
    <>
      <button onClick={showModal} aria-label="Edit Address Details">
        <BtnEditSvg size={30} />
      </button>
      <Modal
        title="Update Address Details"
        open={isModalOpen}
        onCancel={handleCancel}
        width={600}
        centered
        destroyOnClose
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button type="primary" onClick={() => form.submit()}>
              Update
            </Button>
          </div>
        }
        styles={{
          body: {
            maxHeight: "60vh",
            overflowY: "auto",
            overflowX: "hidden",
            padding: "16px 24px",
          },
        }}
      >
        <Form
          form={form}
          name="addressDetails"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item name="EmployeeId" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="DataStatus" hidden>
            <Input />
          </Form.Item>

          <div className="mb-4">
            <h3 className="text-lg font-semibold mb-2">Current Address</h3>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                label="Street Address"
                name="CStreetAddress"
                rules={[{ required: true, message: "Please enter the street address!" }]}
              >
                <Input
                  placeholder="Enter street address"
                  onChange={(e) => handleStreetChange(e, "C")}
                />
              </Form.Item>

              <Form.Item
                label="Country"
                name="CCountryId"
                rules={[{ required: true, message: "Please select a country!" }]}
              >
                <Select
                  placeholder="Select country"
                  onChange={(value) => handleCountryChange(value, "C")}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterSelectOption}
                  loading={!masterData?.CountriesMaster}
                >
                  {masterData?.CountriesMaster?.map((country) => (
                    <Option key={country.CountryId} value={country.CountryId}>
                      {country.CountryName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="State"
                name="CStateId"
                rules={[{ required: true, message: "Please select a state!" }]}
              >
                <Select
                  placeholder="Select state"
                  onChange={(value) => handleStateChange(value, "C")}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterSelectOption}
                  loading={!masterData?.StatesMaster}
                >
                  {masterData?.StatesMaster?.filter(
                    (state) =>
                      !form.getFieldValue("CCountryId") ||
                      state.CountryId === form.getFieldValue("CCountryId")
                  ).map((state) => (
                    <Option key={state.StateId} value={state.StateId}>
                      {state.StateName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="City"
                name="CCityId"
                rules={[{ required: true, message: "Please select a city!" }]}
              >
                <Select
                  placeholder="Select city"
                  onChange={(value) => handleCityChange(value, "C")}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterSelectOption}
                  loading={!cities}
                >
                  {cities?.filter(
                    (city) => city.StateId === form.getFieldValue("CStateId")
                  ).map((city) => (
                    <Option key={city.CityId} value={city.CityId}>
                      {city.CityName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Zip Code"
                name="CZipCode"
                rules={[{ required: true, message: "Please enter the zip code!" }]}
              >
                <Input
                  placeholder="Enter zip code"
                  onChange={(e) => handleZipChange(e, "C")}
                />
              </Form.Item>
            </div>
          </div>

          <Form.Item>
            <Checkbox
              checked={isSameAsCurrent}
              onChange={handleSameAsCurrentChange}
            >
              Permanent address same as current address
            </Checkbox>
          </Form.Item>

          <div>
            <h3 className="text-lg font-semibold mb-2">Permanent Address</h3>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                label="Street Address"
                name="PStreetAddress"
                rules={[{ required: !isSameAsCurrent, message: "Please enter the street address!" }]}
              >
                <Input
                  placeholder="Enter permanent street address"
                  disabled={isSameAsCurrent}
                />
              </Form.Item>

              <Form.Item
                label="Country"
                name="PCountryId"
                rules={[{ required: !isSameAsCurrent, message: "Please select a country!" }]}
              >
                <Select
                  placeholder="Select country"
                  onChange={(value) => handleCountryChange(value, "P")}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterSelectOption}
                  disabled={isSameAsCurrent}
                  loading={!masterData?.CountriesMaster}
                >
                  {masterData?.CountriesMaster?.map((country) => (
                    <Option key={country.CountryId} value={country.CountryId}>
                      {country.CountryName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="State"
                name="PStateId"
                rules={[{ required: !isSameAsCurrent, message: "Please select a state!" }]}
              >
                <Select
                  placeholder="Select state"
                  onChange={(value) => handleStateChange(value, "P")}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterSelectOption}
                  disabled={isSameAsCurrent}
                  loading={!masterData?.StatesMaster}
                >
                  {masterData?.StatesMaster?.filter(
                    (state) =>
                      !form.getFieldValue("PCountryId") ||
                      state.CountryId === form.getFieldValue("PCountryId")
                  ).map((state) => (
                    <Option key={state.StateId} value={state.StateId}>
                      {state.StateName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="City"
                name="PCityId"
                rules={[{ required: !isSameAsCurrent, message: "Please select a city!" }]}
              >
                <Select
                  placeholder="Select city"
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterSelectOption}
                  disabled={isSameAsCurrent}
                  loading={!cities && !permanentCities?.length}
                >
                  {(permanentCities?.length ? permanentCities : cities)?.filter(
                    (city) => city.StateId === form.getFieldValue("PStateId")
                  ).map((city) => (
                    <Option key={city.CityId} value={city.CityId}>
                      {city.CityName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Zip Code"
                name="PZipCode"
                rules={[{ required: !isSameAsCurrent, message: "Please enter the zip code!" }]}
              >
                <Input
                  placeholder="Enter permanent zip code"
                  disabled={isSameAsCurrent}
                />
              </Form.Item>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default AddressEditPopup;